import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, MapPin, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy text-sand pt-16 pb-8" data-id="element-21">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-23">
          <div className="col-span-1 md:col-span-2" data-id="element-24">
            <h3 className="font-serif text-2xl tracking-wider uppercase mb-4 text-white" data-id="element-25">
              Cabo Collection
            </h3>
            <p className="text-sand/80 max-w-md mb-6 font-light leading-relaxed" data-id="element-26">
              More than real estate. We are your gateway to the ultimate Cabo
              lifestyle, connecting you with the finest properties and a vetted
              collective of local professionals.
            </p>
            <div className="flex space-x-4" data-id="element-27">
              <a href="#" className="text-sand/80 hover:text-gold transition-colors" data-id="element-28">
                <Instagram size={20} data-id="element-29" />
              </a>
              <a href="#" className="text-sand/80 hover:text-gold transition-colors" data-id="element-30">
                <Facebook size={20} data-id="element-31" />
              </a>
            </div>
          </div>

          <div data-id="element-32">
            <h4 className="font-serif text-lg mb-4 text-white" data-id="element-33">Explore</h4>
            <ul className="space-y-3 text-sm text-sand/80" data-id="element-34">
              <li data-id="element-35">
                <Link to="/buyers" className="hover:text-gold transition-colors" data-id="element-36">
                  For Buyers
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/sellers" className="hover:text-gold transition-colors" data-id="element-38">
                  For Sellers
                </Link>
              </li>
              <li data-id="element-39">
                <Link to="/collective" className="hover:text-gold transition-colors" data-id="element-40">
                  The Collective
                </Link>
              </li>
              <li data-id="element-41">
                <Link to="/contact" className="hover:text-gold transition-colors" data-id="element-42">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-43">
            <h4 className="font-serif text-lg mb-4 text-white" data-id="element-44">Connect</h4>
            <ul className="space-y-3 text-sm text-sand/80" data-id="element-45">
              <li className="flex items-center space-x-2" data-id="element-46">
                <MapPin size={16} className="text-gold" data-id="element-47" />
                <span data-id="element-48">Cabo San Lucas, BCS, Mexico</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-49">
                <Phone size={16} className="text-gold" data-id="element-50" />
                <span data-id="element-51">+1 (555) 123-4567</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-52">
                <Mail size={16} className="text-gold" data-id="element-53" />
                <span data-id="element-54">hello@cabocollection.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-sand/20 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-sand/60" data-id="element-55">
          <p data-id="element-56">
            &copy; {new Date().getFullYear()} Cabo Collection. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-57">
            Looking for investment deals? Visit our sister site:{' '}
            <a href="https://cabodealflow.com" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-white transition-colors" data-id="element-58">
              CaboDealFlow.com
            </a>
          </p>
        </div>
      </div>
    </footer>;
}